import classNames from 'classnames';
import { lessAgressiveColorMapper } from 'components/PostTrade/ProductModification/components/ValidationErrors.utils';
import type { NotReadySidePanelProps } from 'components/secondaryMarket/cpOrder/sidePanel/notReady/NotReadySidePanel.connect';
import { ActionButton, ButtonPanel, MessagesPanel } from 'components/secondaryMarket/shared/status';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { useToggleFeature } from 'hooks/useToggleFeature';
import type { SecondaryMarketCpOrderForm } from 'state/secondaryMarket/cpOrder/cpOrderForm/input/cpOrderInputForm.model';

import { KycScore } from '../../../shared/status/KycScore';
import { Comment } from '../ready/comment';

export function NotReadySidePanel({
  children,
  validationErrors,
  backendReports,
  onCommentChanged,
  comment,
  kycScore,
  kycDetails,
  className,
}: NotReadySidePanelProps) {
  const isKycHidden = useToggleFeature('HideKYCDisplayParis');
  return (
    <div className={classNames('d-flex flex-column overflow-y-auto', className)}>
      <PanelHeader textColor="secondary" color="primary" discreet />
      <PanelFooter
        textColor="secondary"
        color="primary"
        statusKey="secondaryMarket.sidePanel.label.notReady"
        discreet
        icon="not_ready"
      />
      {!isKycHidden && kycScore !== undefined && <KycScore className="m-2" status={kycScore} details={kycDetails} />}
      <MessagesPanel<SecondaryMarketCpOrderForm>
        errors={[...validationErrors, ...backendReports]}
        className="flex-grow-1 pt-2"
        e2e="side-panel-header"
        colorToSeverity={lessAgressiveColorMapper}
      >
        {children}
      </MessagesPanel>
      <ButtonPanel>
        <Comment comment={comment} onCommentChanged={onCommentChanged} />
        <ActionButton color="primary" label="secondaryMarket.sidePanel.label.placeOrder" disabled />
      </ButtonPanel>
    </div>
  );
}

NotReadySidePanel.displayName = 'NotReadySidePanel';
